import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenchmarkStarsComponent } from './benchmark-stars.component';
import { FormsModule } from '@angular/forms';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { CellRendererStarsComponent } from './cell-renderer-benchmark-stars/cell-renderer-stars.component';

@NgModule({
  declarations: [BenchmarkStarsComponent, CellRendererStarsComponent],
  imports: [CommonModule, FormsModule, NgbPopoverModule],
})
export class BenchmarkModule {}
